module.exports = __webpack_public_path__ + "082030f5e9ddac4e26d64724427da5e1.mp4";